/** 表示用の整形ユーティリティ */

/** 得点を符号付きで表示する（+100 / -20 / 0） */
export function formatDelta(delta: number): string {
  if (delta > 0) return `+${delta}`;
  return String(delta);
}

/** 解答形式の日本語表記 */
export function answerTypeLabel(type: string): string {
  switch (type) {
    case "text":
      return "記述";
    case "number":
      return "数値";
    case "choice_single":
      return "択一";
    case "choice_multi":
      return "複数選択";
    default:
      return "";
  }
}

/**
 * 解答内容から署名を作る。
 * 冪等キーの管理に使い、「同じ内容の再送」と
 * 「書き換えての再送信」を区別する。
 */
export function answerSignature(input: {
  answer?: string;
  selectedChoiceIds?: string[];
}): string {
  if (input.selectedChoiceIds !== undefined) {
    return `c:${[...input.selectedChoiceIds].sort().join(",")}`;
  }
  return `t:${input.answer ?? ""}`;
}
